import { GetRequest, PutRequest } from "../../../plugins/https";
import { setUsername, setPassword, getAdminDetails } from "./action";
import { SET_USERNAME, SET_PASSWORD, GET_DETAILS } from "./actionType";

export const updateDetails = (details) => async (dispatch) => {
  try {
    const res = await PutRequest("/auth/update_details", details);
    dispatch(setUsername(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const updatePassword = (password) => async (dispatch) => {
  try {
    const res = await PutRequest("/auth/update_password", password);
    dispatch(setPassword(res.data));
  } catch (error) {
    console.error(error);
  }
};

export const getDetails = async (dispatch) => {
  try {
    const res = await GetRequest("/auth");
    console.log("The data is", res);

    dispatch(getAdminDetails(res.data.data));
  } catch (error) {
    console.error("Error in getting details: ", error);
  }
};

const initialState = {
  details: {}, // Username state (if needed)
  detailsData: {}, // Assuming detailsData is an object
  password: "", // Password state
};

export const detailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USERNAME:
      return {
        ...state,
        details: action.payload,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    case GET_DETAILS:
      return {
        ...state,
        detailsData: action.payload, // Assuming it's an object
      };
    default:
      return state;
  }
};
